import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// httpOnly cookies (`access_token`, `refresh_token`) are set by the backend on login
// and sent automatically because withCredentials=true. We never touch them from JS,
// which keeps them safe from XSS. No client-side token storage.
const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  // Phase 13 Beat 4 UAT Bug 2 — backends may raise HTTPException with a rich
  // dict detail like {code, message, hint}. Prefer `message` when present.
  if (detail && typeof detail.message === "string") {
    return detail.hint ? `${detail.message} ${detail.hint}` : detail.message;
  }
  return String(detail);
}

export default api;
